export const LOGIN_SLIDER = [
  {
    heading: 'In-Patient Management',
    description: 'A simplified workflow to help insurance co to connect to hospital teams to manage and track in-patient workflows on a single platform from intimation to settlements.',
    imgSrc: require('../../assets/img/slider/slide-1.png'),
  }, {
    heading: 'Out-Patient Management',
    description: 'A seamless appointment management feature that allows insurance co to connect to front desk personnel to confirm/reschedule appointment requests',
    imgSrc: require('../../assets/img/slider/slide-2.png'),
  }, {
    heading: 'Global Distribution system',
    description: 'A feature that helps you to access real-time availability of services like Doctors, Health check and IP packages at the hospitals.',
    imgSrc: require('../../assets/img/slider/slide-3.png'),
  }, {
    heading: 'Hospital Contract management',
    description: 'Connect to a wide Network of hospitals to empanel and renew contracts on a single platform.',
    imgSrc: require('../../assets/img/slider/slide-4.png'),
  }, {
    heading: 'Revenue Cycle Management',
    description: 'A solution that enables Insurance co to collect NDC in real time.',
    imgSrc: require('../../assets/img/slider/slide-5.png'),
  }, {
    heading: 'Database Security',
    description: 'The secured cloud-based platform ensures that patient data and billing information is secure and protected at all times.',
    imgSrc: require('../../assets/img/slider/slide-6.png'),
  },
];
